import { c as _c } from "react/compiler-runtime";
import { Image } from '@/components/client';
import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';
const NOTICE_IMAGE_URL = getStaticCdnUrl('donation/delivery-notice-chuseok.png');

/** 원본 자산 픽셀 크기 — 슬롯 비율이 여기서 파생되므로 자산 교체 시 함께 갱신한다 */
const NOTICE_IMAGE_WIDTH = 3_240;
const NOTICE_IMAGE_HEIGHT = 4_206;
const NOTICE_START_AT = '2026-09-21T00:00:00+09:00';
const NOTICE_END_AT = '2026-09-28T23:59:59+09:00';
export const DeliveryNoticeImage = () => {
  const $ = _c(1);
  if (!checkTodayInRange(NOTICE_START_AT, NOTICE_END_AT)) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src={NOTICE_IMAGE_URL} alt={"9\uC6D4 \uCD94\uC11D\uC5F0\uD734 \uBC30\uC1A1 \uC548\uB0B4. 9\uC6D4 24\uC77C(\uBAA9)\uBD80\uD130 27\uC77C(\uC77C)\uAE4C\uC9C0 \uD0DD\uBC30\uC0AC\uAC00 \uD734\uBB34\uC774\uBA70, 9\uC6D4 28\uC77C(\uC6D4)\uBD80\uD130 \uC21C\uCC28 \uCD9C\uACE0\uB429\uB2C8\uB2E4. \uD734\uBB34 \uC804\uC77C\uC778 9\uC6D4 23\uC77C(\uC218) \uC8FC\uBB38 \uAC74\uC740 9\uC6D4 28\uC77C(\uC6D4)\uBD80\uD130 \uC21C\uCC28\uC801\uC73C\uB85C \uCD9C\uACE0\uB418\uBA70, \uC5F0\uD734 \uC774\uD6C4 \uD0DD\uBC30 \uBB3C\uB7C9 \uC99D\uAC00\uB85C \uBC30\uC1A1\uC774 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4."} width={NOTICE_IMAGE_WIDTH} height={NOTICE_IMAGE_HEIGHT} className="h-auto w-full" sizes="(max-width: 768px) 100vw, 850px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};